import Box from '@mui/material/Box';
import { SearchQuery } from 'functions/src/types/firestore/SearchQuery';
import { Search } from 'functions/src/types/firestore/Search';
import { AutoCompleteResult } from './AutoCompleteResult';

type CachedResult = Search;

type AutoCompleteSectionProps = {
  globalQueries: SearchQuery[];
  searchQuery: string;
  suggestions: string[];
  cachedResults: CachedResult[];
  setSearchQuery: (query: string) => void;
};

export const AutoCompleteSection = ({
  globalQueries,
  searchQuery,
  suggestions,
  cachedResults,
  setSearchQuery,
}: AutoCompleteSectionProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      {globalQueries.length > 0
        ? globalQueries
            .filter((item) =>
              item.query.toLowerCase().includes(searchQuery.toLowerCase()),
            )
            .filter((item) => item.query !== searchQuery)
            .slice(0, 2)
            .map((item) => {
              return (
                <Box
                  key={item.query}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <AutoCompleteResult
                    key={item.query}
                    result={item.query}
                    searchQuery={searchQuery}
                    handleClick={() => setSearchQuery(item.query)}
                    variant="trending"
                  />
                </Box>
              );
            })
        : ''}
      {suggestions.length
        ? suggestions
            .filter((item) =>
              item.toLowerCase().includes(searchQuery.toLowerCase()),
            )
            .slice(0, 2)
            .filter((item) => item !== searchQuery)
            .map((item) => {
              return (
                <Box
                  key={item}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <AutoCompleteResult
                    result={item}
                    searchQuery={searchQuery}
                    variant="suggestion"
                    handleClick={() => setSearchQuery(item)}
                  />
                </Box>
              );
            })
        : ''}
      {cachedResults.length
        ? cachedResults
            .filter((item) =>
              item.title.toLowerCase().includes(searchQuery.toLowerCase()),
            )
            .filter(
              (item) => item.title.toLowerCase() !== searchQuery.toLowerCase(),
            )
            .slice(0, 2)
            .map((item) => {
              return (
                <Box
                  key={item.title}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <AutoCompleteResult
                    result={item.title}
                    searchQuery={searchQuery}
                    variant="recent"
                    handleClick={() => setSearchQuery(item.title)}
                  />
                </Box>
              );
            })
        : ''}
    </Box>
  );
};
